import { Dispatch, SetStateAction } from 'react';

import { IReferentials } from '../../referential/reducers';
import { TeamMemberFormType } from '../enums';
import { ITeam, ITeamMember } from '../reducers';

export interface ModalTeamMemberFormProps {
  actionRequest: (teamMember: ITeamMember) => Promise<unknown>;
  referentials: IReferentials;
  reloadTeam: () => Promise<unknown>;
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  team: ITeam;
  teamMember: ITeamMember;
  type: TeamMemberFormType;
}

interface FormTypeText {
  title: string;
  subtitle: string;
  success: string;
  error: string;
}

export const formTypeText: Record<TeamMemberFormType, FormTypeText> = {
  [TeamMemberFormType.CREATE]: {
    title: 'Ajouter un collaborateur',
    subtitle: 'Un email sera automatiquement envoyé à votre nouveau collaborateur lors de la création de son compte',
    success: "Nouveau collaborateur enregistré dans l'équipe",
    error: "Le nouveau collaborateur n'est pas enregistré, veuillez corriger les erreurs du formulaire"
  },
  [TeamMemberFormType.UPDATE]: {
    title: 'Modifier un collaborateur',
    subtitle: "Modifier les informations de l'utilisateur ainsi que sa disponibilité",
    success: 'La modification du collaborateur a été enregistré',
    error: "La modification du collaborateur n'a pas été enregistrée, veuillez corriger les erreurs du formulaire"
  }
};
